import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const defaultPricesManagementReducer = foxGridReducer(
  gridNames.defaultPricesManagement,
);

export default defaultPricesManagementReducer;
